import { TextHeadline1 } from '@blocket/blocket-ui'
import ColorBar from '@blocket/blocket-ui/lib/commonjs/components/TabBar/ColorBar'
import pulse from '@blocket/tracking-pulse'
import Header from 'components/Header'
import VerificationModal from 'components/Modal/VerificationModal'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actionCreators as selectAdInsertionActionCreators } from 'reduxBits/selectAdInsertion/actions'
import { getPulseOrigin } from 'utils/pulse'
import {
  BusinessCard,
  CarCard,
  ElectronicCard,
  HobbyCard,
  HomeCard,
  JobCard,
  OtherCard,
  PersonalCard,
  ResidenceCardNew,
} from './Cards'
import  CompanyBlueInfoBox, { CompanyAdInsertionLink }  from './CompanyAdInsertionLink'
import { ColoredResponsivePage, ContentWrap, FullHeightWrapper } from './layout'
export class SelectFlowComponent extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      width: undefined,
    }
  }

  componentDidMount() {
    pulse.pageView({
      type: 'View',
      object: {
        type: 'Page',
        name: 'Slussen',
        id: 'slussen-page',
      },
      origin: getPulseOrigin(),
    })

    if (typeof window !== 'undefined') {
      // Handler to call on window resize
      const handleResize = () => {
        // Set window width/height to state
        this.setState({
          width: window.innerWidth,
        })
      }

      // Add event listener
      window.addEventListener('resize', handleResize)

      // Call handler right away so state gets updated with initial window size
      handleResize()
    }
  }

  render() {
    const { selectAdInsertionActions, verificationModalType, verificationRedirectUri } = this.props

    const { width } = this.state

    return (
      <FullHeightWrapper>
        <ColorBar />
        <Header
          cancelBtnText="Avbryt"
          cancelBtnEvent={async () => {
            await selectAdInsertionActions.selectAdInsertionInteraction({
              id: 'cancel',
              url: window.location.href,
            })
            window.location.href = '/'
          }}
        />
        {!!verificationModalType && (
          <VerificationModal
            tag="new_slussen"
            redirectUri={verificationRedirectUri}
            cancelUri="/mina-annonser/lagg-in-annons"
          />
        )}
        <ColoredResponsivePage mobileMaxWidth={980} desktopMaxWidth={980}>
          <TextHeadline1>Vad vill du annonsera?</TextHeadline1>
          {width < 768 && (
            <ContentWrap>
              <CompanyBlueInfoBox />
            </ContentWrap>
          )}
          <CompanyAdInsertionLink />
          <ContentWrap>
            {width < 768 ? (
              // mobile
              <>
                <HomeCard />
                <CarCard />
                <HobbyCard />
                <ElectronicCard />
                <PersonalCard />
                <ResidenceCardNew/>
                <JobCard />
                <BusinessCard />
                <OtherCard />
              </>
            ) : (
              // desktop
              <>
                <HomeCard />
                <HobbyCard />
                <ElectronicCard />
                <PersonalCard />
                <OtherCard />
                <CarCard />
                <ResidenceCardNew/>
                <JobCard />
                <BusinessCard />
              </>
            )}
          </ContentWrap>
          {width > 768 && (
            <ContentWrap>
              <CompanyBlueInfoBox />
            </ContentWrap>
          )}
        </ColoredResponsivePage>
      </FullHeightWrapper>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectAdInsertionActions: bindActionCreators(selectAdInsertionActionCreators, dispatch),
})

const mapStateToProps = (state) => ({
  verificationModalType: state.verification.modal?.type,
  verificationRedirectUri: state.verification.modal?.redirectUri,
})

SelectFlowComponent.propTypes = {
  selectAdInsertionActions: PropTypes.object.isRequired,
  verificationModalType: PropTypes.string,
  verificationRedirectUri: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectFlowComponent)
